/* eslint-disable unicorn/filename-case */
import { WebWrapper } from '../../components/WebWrapper'

import Coins from './Coins'

export default () => (
  <WebWrapper maxWidth={'1000px'}>
    <Coins />
  </WebWrapper>
)
